// This file is automatically generated. DO NOT EDIT.

import { getCoreURL } from '@api/internal';

export interface GetPaceDataRequest {
  region: 'eu' | 'us';
  userAuth?: string | undefined;
  seriesId: string;
}

export function getPaceDataRequest(requestParams: GetPaceDataRequest): Request {
  const coreURL = getCoreURL(requestParams.region);
  const url = `${coreURL}/presentation/series/${requestParams.seriesId}/pace-data`;
  return new Request(url, {
    method: 'GET',
    headers: {
      ...(requestParams.userAuth && {
        Authorization: `Bearer ${requestParams.userAuth}`,
      }),
    },
  });
}
